import { useContainer } from "#imports";
import { DependencyInjectId } from "@@/package/const/DependencyInjectId";
import OrganizationMapper from "~~/package/mapper/organization/OrganizationMapper";
import {
    OrganizationProSkillManagerInfoModel
} from "~~/package/mapper/organization/model/OrganizationProSkillManagerInfoModel";
import { OrganizationSettingsInfoModel } from "~~/package/mapper/organization/model/OrganizationSettingsInfoModel";
import type {PageModel} from '~~/package/mapper/common/model/PageModel';
import type {OrganizationMemberModel} from '~~/package/mapper/organization/model/OrganizationMemberModel';
import { OrganizationInviteMemberModel } from "~~/package/mapper/organization/model/OrganizationInviteMemberModel";
import OrganizationInviteResponse from "~~/package/apis/organization/response/OrganizationInviteResponse";
import { UserV2Type } from "~~/package/mapper/user/model/UserType";
import { MemberMenuAccessRole } from "~~/package/mapper/organization/model/OrganizationMemeberTypes";
import type OrganizationAcceptInviteMemberResponse
    from '~~/package/apis/organization/response/OrganizationAcceptInviteMemberResponse';

export const useOrganizationService = () => {
    const organizationMapper = useContainer<OrganizationMapper>(DependencyInjectId.OrganizationMapper);

    const getOrganizationProSkillManagerInfo = (): Promise<OrganizationProSkillManagerInfoModel> => {
        return organizationMapper.getOrganizationProSkillManagerInfo();
    };

    const getOrganizationSettingsInfo = (): Promise<OrganizationSettingsInfoModel> => {
        return organizationMapper.getOrganizationSettingsInfo();
    }

    const getOrganizationMember = (page: number, size: number, sort?: string, keyword?: string): Promise<PageModel<OrganizationMemberModel>> => {
        return organizationMapper.getOrganizationMember(page, size, sort, keyword);
    }

    const updateOrganizationSettingsInfo = (name: string, size: string): Promise<OrganizationSettingsInfoModel> => {
        return organizationMapper.updateOrganizationSettingsInfo(name, size)
    }

    const deleteMyOrganization = (): Promise<boolean> => {
        return organizationMapper.deleteMyOrganization()
    }

    const createOrganization = (name: string, size: string): Promise<boolean> => {
        return organizationMapper.createOrganization(name, size);
    };

    const inviteOrganizationMembers = (invitations: OrganizationInviteMemberModel[]): Promise<OrganizationInviteResponse> => {
        return organizationMapper.inviteOrganizationMembers(invitations);
    };

    const updateOrganizationMemberRole = (userUuid: string, organizationRole: UserV2Type, menuAccessRoles?: MemberMenuAccessRole[]): Promise<boolean> => {
        return organizationMapper.updateOrganizationMemberRole(userUuid, organizationRole, menuAccessRoles);
    };

    const deleteOrganizationMember = (userUuids: string[]): Promise<boolean> => {
        return organizationMapper.deleteOrganizationMember(userUuids)
    }

    const acceptInviteMember = (userUuid: string, orgUuid: string): Promise<OrganizationAcceptInviteMemberResponse> => {
        return organizationMapper.acceptInviteMember(userUuid, orgUuid);
    };

    return {
        getOrganizationProSkillManagerInfo,
        getOrganizationSettingsInfo,
        getOrganizationMember,
        updateOrganizationSettingsInfo,
        deleteMyOrganization,
        createOrganization,
        inviteOrganizationMembers,
        updateOrganizationMemberRole,
        deleteOrganizationMember,
        acceptInviteMember
    };
}
